import { render, staticRenderFns } from "./TypesOfCases.vue?vue&type=template&id=c38ed7f0&scoped=true"
import script from "./TypesOfCases.vue?vue&type=script&lang=js"
export * from "./TypesOfCases.vue?vue&type=script&lang=js"
import style0 from "./TypesOfCases.vue?vue&type=style&index=0&id=c38ed7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38ed7f0",
  null
  
)

export default component.exports